import '../sass/searchengine.sass';
import {ScrollSnapArrows} from "./scroll-snap-arrows";

document.addEventListener('DOMContentLoaded', function () {

    let searchInput: HTMLInputElement = document.querySelector('#input_search');
    let searchInputMobile = document.querySelector('#input_mobile');
    let searchContainer = document.querySelector('.search_container');
    let searchResults = document.querySelector('#search_results');
    let closeSearch = document.querySelector('#close_search');
    let eraseSearch = document.querySelector('#erase_search');
    let fetchPage: () => void;

    for (let searchIcon of document.querySelectorAll('.header__search')) {
        searchIcon.addEventListener('click', function () {
            const isActive = searchContainer.classList.contains('search--active');
            
            if (isActive) {
                // Fermer
                document.body.classList.remove('no-scroll');
                searchContainer.classList.remove('search--active');
            } else {
                // Ouvrir
                document.body.classList.add('no-scroll');  
                searchContainer.classList.add('search--active');
                searchInput.focus();
                fetchPage();
            }
        });
    }

    if (closeSearch) {
        closeSearch.addEventListener('click', function () {
            document.body.classList.remove('no-scroll');
            searchContainer.classList.remove('search--active');
            searchInput.value = '';
            searchResults.innerHTML = '';
        });
    }
    let erasing = false;
    if (eraseSearch) {
        eraseSearch.addEventListener('click', function () {
            erasing = true
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('keyup'));
            erasing = true;
        });
    }

    if (searchInputMobile) {
        searchInputMobile.addEventListener('focus', function () {
            document.body.classList.add('no-scroll');  
            searchContainer.classList.add('search--active');
            searchInput.focus();
        });
    }

    let page = 1;
    let stop = false;
    let waiting = false;
    let previousValue = ''

    let currentTimeout: number;
    if (searchInput) {
        searchInput.addEventListener('keyup', function () {
            if (previousValue === searchInput.value) {
                return;
            }
            previousValue = searchInput.value
            clearTimeout(currentTimeout);
            currentTimeout = setTimeout(function () {
                page = 1;
                if (searchInput.value.length === 0 && !erasing) {
                    document.body.classList.remove('no-scroll');
                    searchContainer.classList.toggle('search--active');
                    // navbar.classList.remove('black');
                } else {
                    waiting = true;
                    innerWidth = window.innerWidth
                    fetch(`/search/light/${searchInput.value}`)
                        .then(result => result.text())
                        .then(result => {
                            stop = result.trim() === "";
                            waiting = false;
                            searchResults.innerHTML = result;
                            if (searchResults.clientHeight === searchResults.scrollHeight && !waiting && !stop) {
                                fetchPage();
                            }
                        });
                    if (searchInput.value.length === 0) {
                        // navbar.classList.remove('black');
                    }
                }
            }, 300);
        });
    }

    fetchPage = () => {
        waiting = true
        page++
        fetch(`/search/light/${searchInput.value}`)
            .then(result => result.text())
            .then(result => {
                stop = result.trim() === "";
                waiting = false;
                searchResults.innerHTML = result;

                const carousels = searchResults.querySelectorAll('.carousel');
                carousels.forEach(carousel => {
                    const manual = new ScrollSnapArrows(carousel.querySelector('.carousel__content'));
                    manual.addArrow('left', carousel.querySelector('.carousel-arrow__left'));
                    manual.addArrow('right', carousel.querySelector('.carousel-arrow__right'));
                });

            });
    }
});
